// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"93":"Error404","315":"RoomWatcher","416":"RoomEnter","438":"Login","732":"DevLogin","879":"Detection"}[chunkId] + "." + {"93":"9c161374","315":"516fdca2","416":"9c161374","438":"25cf6e9b","732":"d9117502","879":"051da54a"}[chunkId] + ".css";
};